import api from 'api'
import Constants from 'Constants'

const { SERVER_PAYMENTS_URL } = Constants

const fortisApi = api.injectEndpoints({
  endpoints: builder => ({
    // Creates a Fortis Elements Transaction Intention and returns the server response (should include client_token)
    fortisCreateTransactionIntention: builder.mutation({
      query: ({ ...rest }) => ({
        url: `${SERVER_PAYMENTS_URL}/api/crm/get-element`,
        method: 'POST',
        body: {
          ...rest,
        },
      }),
    }),
  }),
})

export const { useFortisCreateTransactionIntentionMutation } = fortisApi
